import { Box, MenuItem, Select, Typography } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'
const CustomDropDown = ({
  disabled,
  value,
  onChange,
  NoData,
  menuList,
  placeholder,
  sx = {},
  style = {},
  errors,
  Title,
  isLoading,
  getLabel,
  name
}) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0px" }}>
      {Title && (
        <Typography
          sx={{
            color: "black",
            fontWeight: "400",
            textAlign: "left",
            fontFamily: 'Outfit',
            fontSize: { xs: "14px", sm: "16px" },
            ...style,
          }}
        >
          {Title}
        </Typography>
      )}
      {isLoading ? (
        <Skeleton height={"60px"} />
      ) : (
        <Select
          sx={{
            width: "100%",
            height: "60px",
            borderRadius: "15px",
            background: "rgba(255, 255, 255, 1)",
            fontFamily: 'Poppins',
            color: " #00000099",
            "&:focus": {
              outline: "none",
              boxShadow: "none",
            },
            "&:hover": {
              outline: "none",
            },
            ".MuiOutlinedInput-notchedOutline": {
            },
            ...sx,
          }}
          name={name}
          value={value === null ? "" : value}
          onChange={onChange}
          displayEmpty
          disabled={disabled}
        >
          <MenuItem sx={{ display: "none", fontFamily: 'Poppins', fontSize: "28px", color: " #00000099", 
                            opacity:'60%' }} value={""} disabled>
            {placeholder}
          </MenuItem>
          {menuList ? (
            menuList.map((elem, index) => (
              <MenuItem key={index} value={elem.id} sx={{
                fontFamily: "Poppins"
              }}>
                {getLabel ? elem?.name || elem?.full_name : elem?.name}
              </MenuItem>
            ))
          ) : (
            <Typography>{NoData}</Typography>
          )}
        </Select>
      )}
      {errors && (
        <Typography
          sx={{
            color: "red",
            fontWeight: "400",
            fontSize: { xs: "14px", sm: "14px" },
            padding: '0 8px ',
            marginTop: '4px'
          }}
        >
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default CustomDropDown;
